module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.company) ? _c('li', {
    staticClass: "rent-pre-registrations-menu dropdown",
    class: {
      'active': _vm.routeName == 'orders_list'
    }
  }, [_c('audio', {
    ref: "newRents",
    attrs: {
      "src": _vm.cdn('sound.mp3')
    }
  }), _vm._v(" "), _c('audio', {
    ref: "newRentSound",
    attrs: {
      "src": _vm.cdn('beep.mp3')
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": {
        name: 'orders_list'
      },
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n    Display"), (_vm.countOrders > 0) ? _c('span', {
    staticClass: "bell-badge"
  }, [_vm._v(_vm._s(_vm.countOrders))]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41c89e90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/RentPreRegistrationsMenu.vue
// module id = 991
// module chunks = 34